<template>
  <li>
    <span class="nested-category-item">
      <span
        class="nested-category-label"
        :class="{ 'font-medium text-blue-600': isActive }"
        @click="onSelect"
      >
        {{ category.description }}
      </span>
      <OurSvgIcon
        v-if="category.children.length"
        :src="icons.AngleRight"
        size="sm"
        color="gray"
        class="nested-category-arrow"
        :class="{ 'rotate-90': isExpanded }"
        @click.stop="toggle"
      />
    </span>
    <ul v-if="isExpanded && childCategories.length" class="subcategory">
      <NestedCategoryItem
        v-for="child in childCategories"
        :key="child.id"
        :category="child"
        :items="items"
        :active-category-id="activeCategoryId"
        @select="$emit('select', $event)"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: "NestedCategoryItem",

  props: {
    category: {
      type: Object,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    activeCategoryId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      isExpanded: false,
    };
  },

  computed: {
    icons: () => ({
      AngleRight: require("@/components/_bit/IconSvg/icons/Angle-right.svg"),
    }),

    isActive() {
      return this.activeCategoryId && String(this.category.id) === String(this.activeCategoryId);
    },

    childCategories() {
      if (!this.category.children?.length) {
        return [];
      }

      return this.category.children
        .map((id) => this.items.find((item) => item.id === id))
        .filter(
          (item) => item && (item.parent === this.category.id || item.parentId === this.category.id)
        );
    },
  },

  watch: {
    activeCategoryId: {
      handler() {
        this.syncExpandedState();
      },
      immediate: true,
    },

    items() {
      this.syncExpandedState();
    },
  },

  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },

    onSelect() {
      this.$emit("select", this.category.id);
    },

    findCategory(id) {
      if (!id) {
        return null;
      }

      return this.items.find((item) => String(item.id) === String(id)) || null;
    },

    getParentId(category) {
      if (!category?.parent && category?.parent !== 0) {
        return category?.parentId ?? null;
      }

      if (category.parent === null) {
        return null;
      }

      if (typeof category.parent === "object") {
        return category.parent.id ?? null;
      }

      return category.parentId ?? category.parent ?? null;
    },

    getCategoryPath(categoryId) {
      const path = [];
      let current = this.findCategory(categoryId);

      while (current) {
        path.unshift(current);
        const parentId = this.getParentId(current);

        current = parentId ? this.findCategory(parentId) : null;
      }

      return path;
    },

    syncExpandedState() {
      if (!this.activeCategoryId || !this.items.length) {
        return;
      }

      const path = this.getCategoryPath(this.activeCategoryId);
      const index = path.findIndex((item) => String(item.id) === String(this.category.id));

      if (index >= 0 && index < path.length - 1) {
        this.isExpanded = true;
      }
    },
  },
};
</script>
